'use strict';

var React = require('react');
var index_es = require('./index.es-8c72aff8.js');
var WidgetController_widgets_AppCards_type = require('./WidgetController/widgets/AppCards/type.js');
var AppCard = require('./AppCard-1dcce203.js');
var useEffectOnce = require('./useEffectOnce-5d273a5b.js');
var constants = require('./constants-1c2b78a5.js');
var styled = require('styled-components');
var WidgetControllerContext = require('./WidgetControllerContext-924d4968.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const GridContainer = styled__default['default'].div(({ theme }) => ({
    display: "grid",
    gap: theme.spacing.xSmall,
    gridTemplateColumns: "auto auto auto auto auto",
    rowGap: theme.spacing.large,
    margin: `${theme.spacing.large} 0 0 0`,
}));
const ListContainer = styled__default['default'].div `
    &::-webkit-scrollbar {
        display: none;
    }
    display: flex;
    overflow-x: scroll;
    overflow-y: hidden;
    scrollbar-width: none;
    -webkit-overflow-scrolling: touch;
    margin-top: ${(props) => props.theme.spacing.medium};
    margin-bottom: ${(props) => props.theme.spacing.medium};
    padding-left: ${(props) => props.theme.spacing.medium};
`;

const GridLayoutCards = ({ cards, size, clickHandler }) => {
    const [appsToRender, setAppsToRender] = React.useState([]);
    useEffectOnce.useEffectOnce(() => {
        const apps = cards.slice(0, 9);
        apps.push(Object.assign(Object.assign({}, constants.LOT_MORE_CARD), { clickHandler }));
        setAppsToRender(apps);
    });
    return (React__default['default'].createElement(GridContainer, null, appsToRender.map((app) => {
        return React__default['default'].createElement(AppCard.AppCard, { app: app, size: size, key: app.name });
    })));
};
var GridLayoutCards$1 = React__default['default'].memo(GridLayoutCards);

const HorizontalLayoutCards = ({ cards, size }) => {
    return (React__default['default'].createElement(ListContainer, null, cards.map((app) => {
        return React__default['default'].createElement(AppCard.AppCard, { app: app, size: size, key: app.name });
    })));
};
var HorizontalLayoutCards$1 = React__default['default'].memo(HorizontalLayoutCards);

const AppCards = ({ listType, cards = [], dataSource, apps, size = WidgetController_widgets_AppCards_type.CardSize.SMALL, popularApps, lotMoreClickAction, analytics, }) => {
    const { clickAnalytics, impressionAnalytics, sdk } = React.useContext(WidgetControllerContext.WidgetControllerContext);
    React.useEffect(() => {
        if (!index_es.N(analytics)) {
            if (!index_es.N(analytics.impressionObjectName) && !index_es.N(impressionAnalytics)) {
                impressionAnalytics({
                    action: analytics.impressionObjectName,
                    category: analytics.screenName,
                    context: AppCard.getContext(apps, cards),
                });
            }
        }
    }, [impressionAnalytics, analytics, apps, cards]);
    const clickHandler = React.useCallback(() => {
        if (!sdk || !lotMoreClickAction)
            return;
        if (!index_es.N(analytics)) {
            if (!index_es.N(analytics.clickObjectName) && !index_es.N(clickAnalytics)) {
                clickAnalytics({
                    action: analytics.clickObjectName,
                    category: analytics.screenName,
                    label: analytics.objectValue,
                });
            }
        }
        sdk[lotMoreClickAction.name](lotMoreClickAction.params);
    }, [analytics, clickAnalytics, lotMoreClickAction, sdk]);
    const appsToRender = React.useMemo(() => {
        let appList = dataSource === WidgetController_widgets_AppCards_type.DataSource.APPS ? [] : [...cards];
        if (dataSource === WidgetController_widgets_AppCards_type.DataSource.APPS && !index_es.N(popularApps)) {
            if (!index_es.N(apps)) {
                const wanted = new Set(apps);
                const [presentApps, restApps] = AppCard.partition(popularApps, (app) => wanted.has(app.name));
                appList = [...presentApps, ...restApps];
            }
            else {
                appList = [...popularApps];
            }
        }
        return appList;
    }, [apps, cards, dataSource, popularApps]);
    if (listType === WidgetController_widgets_AppCards_type.ListType.GRID) {
        return React__default['default'].createElement(GridLayoutCards$1, { cards: appsToRender, size: size, clickHandler: clickHandler });
    }
    return React__default['default'].createElement(HorizontalLayoutCards$1, { cards: appsToRender, size: size });
};
var AppCardsWidget = React__default['default'].memo(AppCards);

exports.AppCardsWidget = AppCardsWidget;
//# sourceMappingURL=AppCards-4dd4f077.js.map
